import { AppBar, Box, Container, createTheme, PaletteColorOptions, PaletteOptions, Theme, ThemeOptions, ThemeProvider, Toolbar, Typography, useTheme } from "@mui/material";
import { PropsWithChildren, useContext, useMemo, useState } from "react";
import { CustomLogo } from "../components/custom-logo";
import { Logo } from "../components/logo";
import { IStyleConfig } from "../domain/election";
import { red } from "@mui/material/colors";

export interface MyPaletteOptions extends PaletteOptions {
    layout?: PaletteColorOptions;
    interface?: PaletteColorOptions;
}

const isLight = (color: string) => {
    color = color.replace("#", "");
    const r = color.substring(0, 2);
    const g = color.substring(2, 4);
    const b = color.substring(4, 6);
    const s = Number("0x" + r) + Number("0x" + g) + Number("0x" + b);
    const l = s / (255 * 3)
    console.log({ r, g, b, s, l });
    return l > 0.8;
}

const getTextColor = (background: string) => {
    return isLight(background) ? "#333333" : "#FFFFFF";
}


interface MainLayoutProps extends PropsWithChildren {
    style_config?: IStyleConfig;
    logoSmUrl?: string;
    preview?: boolean;
}
export const MainLayout = ({ children, style_config, logoSmUrl, preview }: MainLayoutProps) => {

    const { electify_logo } = style_config || {};

    const layout_color = useMemo(() => {
        if (!style_config || !style_config.layout_color) {
            return '#344863';
        }
        return style_config.layout_color
    }, [style_config]);

    const interface_color = useMemo(() => {
        if (!style_config || !style_config.interface_color) {
            return '#00adff';
        }
        return style_config.interface_color
    }, [style_config]);

    const success_color = useMemo(() => {
        if (!style_config || !style_config.success_color) {
            return '#2e7d32';
        }
        return style_config.success_color
    }, [style_config]);

    const error_color = useMemo(() => {
        if (!style_config || !style_config.error_color) {
            return '#d32f2f';
        }
        return style_config.error_color
    }, [style_config]);

    const palette = useMemo((): MyPaletteOptions => {
        return {
            layout: {
                main: layout_color,
                contrastText: getTextColor(layout_color)
            },
            interface: {
                main: interface_color,
                contrastText: getTextColor(interface_color)
            },
            success: {
                main: success_color,
                contrastText: getTextColor(success_color)
            },
            error: {
                main: error_color,
                contrastText: getTextColor(error_color)
            }
        };
    }, [layout_color, interface_color, success_color, error_color]);

    const theme: Theme = useMemo(() => {
        return createTheme({
            palette,
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 600,
                    md: 800,
                    lg: 1000,
                    xl: 1200
                }
            },
            typography: {
                h1: {
                    fontSize: 50
                },
                h2: {
                    fontSize: 30
                },
                h3: {
                    fontSize: 20
                }
            }
        })
    }, [palette]);

    return (
        <>
            <ThemeProvider theme={theme}>

                <AppBar position="fixed" color={"layout" as any} sx={{ top: 0 }}>
                    <Toolbar sx={{ display: "flex", justifyContent: "space-between", height: { xs: '38px', sm: '50px' } }}>
                        <Box
                            sx={{ height: "100%" }}
                            maxWidth="40%" display="flex" alignItems="center">
                            <Logo style={electify_logo} />
                            <Typography sx={{ display: { xs: 'none', md: 'initial' } }} pl={3} variant="h6" color="inherit" noWrap>
                                Voting
                            </Typography>
                        </Box>
                        <Box sx={{ height: "100%", display: "flex", alignItems: "center" }}>
                            {preview ? <Typography sx={{ mr: 2 }}>
                                [PREVIEW]
                            </Typography> : null}
                            {logoSmUrl ? <Box height="50px" maxWidth="40%" display="flex" alignItems="center">
                                <CustomLogo url={logoSmUrl} size="w200" />
                            </Box> : null}
                        </Box>
                    </Toolbar>
                </AppBar>

                <Container maxWidth="md" sx={{ paddingTop: "64px" }}>
                    <Box sx={{ my: 4 }}>
                        {children}
                    </Box>
                </Container>
            </ThemeProvider>
        </>
    );
}
